import React, { useState, useEffect } from 'react';
import { Button, Table, Modal, Select, Upload, Tag, message, Form, Input } from 'antd';
import { UploadOutlined, PlusOutlined } from '@ant-design/icons';
import { useRequest } from "ahooks";
import { CardServer, CommonServer } from "../../../server";
// import dayjs from 'dayjs';

const importServe = CardServer.ImportCard
const commonServer = CommonServer.Level
export const CardImport = () => {
  const [visible, setVisible] = useState<any>(false);
  const [cardTypes, setCardTypes] = useState<any[]>([]);
  const [selectedCardType, setSelectedCardType] = useState<any>('');
  const [addModalVisible, setAddModalVisible] = useState<any>(false);
  const [editModalVisible, setEditModalVisible] = useState<any>(false);
  const [editingRecord, setEditingRecord] = useState<any>(null);
  const [form] = Form.useForm();
  const [editForm] = Form.useForm();
  const [dataSource, setDataSource] = useState<any[]>([]);
  // 新增导入相关状态
  const [selectedFile, setSelectedFile] = useState<any>(null);

  const columns = [
    {
      title: '卡片种类',
      dataIndex: 'cardType',
      render(_: any, record: any) {
        return record?.Category?.Name || ''
      },
    },
    {
      title: '卡号',
      dataIndex: 'Number',
      key: 'Number',
    },
    {
      title: '创建时间',
      dataIndex: 'CreatedAtString',
      key: 'CreatedAtString',
    },
    {
      title: '操作',
      key: 'action',
      fixed: 'right' as const,
      width: 100,
      render: (_: any, record: any) => (
        <Button 
          type="link" 
          size="small"
          onClick={() => handleEdit(record)}
        >
          修改
        </Button>
      ),
    },
  ];
  // 获取卡片列表
  const fetchCards = async () => {
    const response = await importServe.list({});
    const data = response && response.length && response.map((item: any) => ({
      ...item,
      key: item.id,
    }));
    setDataSource(data);
  }
  // 获取卡片等级列表
  const fetchCardLevel = async () => {
    const data = await commonServer.entityList({});
    setCardTypes(data);
  };

  // 初始化加载数据
  useEffect(() => {
    fetchCards();
    fetchCardLevel()
  }, []);
  const handleImport = () => {
    setVisible(true);
  };

  const handleCancel = () => {
    setVisible(false);
  };

  // 添加卡片弹窗相关逻辑
  const handleAddCard = () => {
    setAddModalVisible(true);
  };

  // 编辑卡片弹窗相关逻辑
  const handleEdit = (record: any) => {
    setEditingRecord(record);
    // 设置表单初始值
    editForm.setFieldsValue({
      cardType: record?.Category?.Id
    });
    setEditModalVisible(true);
  };

  const handleEditOk = async (values: any) => {
    // 调用后端API
    const response = await importServe.update({
      Id: editingRecord.Id,
      CategoryId: values.cardType,
    });
    if (response) {
      message.success('修改成功');
      setEditModalVisible(false);
      editForm.resetFields();
      setEditingRecord(null);
      fetchCards()
    }
  };

  const handleEditCancel = () => {
    editForm.resetFields();
    setEditingRecord(null);
    setEditModalVisible(false);
  };

  const handleAddOk = async (values: any) => {
    // 调用后端API
    const response = await importServe.addCard({
      CategoryId: values.cardType,
      Number: values.cardNumber,
    });
    if (response) {
      message.success('添加成功');
      setAddModalVisible(false);
      form.resetFields();
      fetchCards()
    }
  };

  const handleAddCancel = () => {
    form.resetFields();
    setAddModalVisible(false);
  };

  //   导入
  // 修改后的上传配置
  const uploadProps = {
    beforeUpload: (file: any) => {
      const isExcel = file.type.includes('excel') || file.type.includes('spreadsheetml');
      const isCSV = file.type === 'text/csv';
      if (!isExcel && !isCSV) {
        message.error('仅支持上传 Excel 或 CSV 文件');
        return Upload.LIST_IGNORE;
      }
      setSelectedFile(file);
      return false; // 阻止自动上传
    },
    accept: '.xlsx, .xls, .csv',
    maxCount: 1,
    showUploadList: {
      showRemoveIcon: true,
      remove: () => setSelectedFile(null)
    }
  };

  // 处理导入确认
  const handleImportConfirm = async () => {
    if (!selectedCardType) {
      message.warning('请选择卡片类型');
      return;
    }
    if (!selectedFile) {
      message.warning('请选择上传文件');
      return;
    }
    const formData = new FormData();
    formData.append('CategoryId', selectedCardType);
    formData.append('File', selectedFile);
    const params = {
      CategoryId: selectedCardType,
      File: selectedFile
    }
    const response = await importServe.import(formData);
    if (response) {
      message.success(`导入成功`);
      setVisible(false);
      fetchCards(); // 刷新列表
    } else {
      message.error(`导入失败`);
    }
  };

  // 重置导入状态
  const resetImportState = () => {
    setSelectedFile(null);
    setSelectedCardType('');
  };

  return (
    <div style={{ padding: 20 }}>
      <div style={{ marginBottom: 16, display: 'flex', justifyContent: 'flex-end' }}>
        <Button type="primary" onClick={handleImport} style={{ marginRight: 8 }}>
          导入
        </Button>
        <Button type="primary" icon={<PlusOutlined />} onClick={handleAddCard}>
          添加卡片
        </Button>
      </div>

      <Table
        columns={columns}
        scroll={{ x: 'max-content' }}
        dataSource={dataSource}
        bordered
      />

      <Modal
        title="导入卡片"
        visible={visible}
        onOk={handleImportConfirm}
        onCancel={() => {
          resetImportState();
          setVisible(false);
        }}
        okText="确认导入"
        cancelText="取消"
      >
        <div style={{ marginBottom: 16 }}>
          <Select
            placeholder="请选择卡片类型"
            style={{ width: '100%' }}
            value={selectedCardType}
            onChange={value => setSelectedCardType(value)}
            options={cardTypes.map(t => ({
              value: t.Id,
              label: t.Name
            }))}
          />
        </div>

        <div style={{ marginBottom: 16 }}>
          <Upload {...uploadProps}>
            <Button icon={<UploadOutlined />}>选择文件（Excel/CSV）</Button>
          </Upload>
          {selectedFile && (
            <div style={{ marginTop: 8 }}>
              已选择文件：{selectedFile.name}
            </div>
          )}
        </div>
      </Modal>

      {/* 编辑卡片弹窗 */}
      <Modal
        title="编辑卡片"
        visible={editModalVisible}
        onCancel={handleEditCancel}
        onOk={() => editForm.submit()}
        okText="确认"
        cancelText="取消"
      >
        <Form
          form={editForm}
          layout="vertical"
          onFinish={handleEditOk}
          autoComplete="off"
        >
          <Form.Item
            label="卡片类型"
            name="cardType"
            rules={[{ required: true, message: '请选择卡片类型' }]}
          >
            <Select placeholder="请选择卡片类型">
              {cardTypes.map(type => (
                <Select.Option key={type.Id} value={type.Id}>
                  {type.Name}
                </Select.Option>
              ))}
            </Select>
          </Form.Item>
        </Form>
      </Modal>

      {/* 新增添加卡片弹窗 */}
      <Modal
        title="添加卡片"
        visible={addModalVisible}
        onCancel={handleAddCancel}
        onOk={() => form.submit()}
        okText="确认"
        cancelText="取消"
      >
        <Form
          form={form}
          layout="vertical"
          onFinish={handleAddOk}
          autoComplete="off"
        >
          <Form.Item
            label="卡片类型"
            name="cardType"
            rules={[{ required: true, message: '请选择卡片类型' }]}
          >
            <Select placeholder="请选择卡片类型"
              onChange={id => setSelectedCardType(id)}
            >
              {cardTypes.map(type => (
                <Select.Option key={type.Id} value={type.Id}>
                  {type.Name}
                </Select.Option>
              ))}
            </Select>
          </Form.Item>

          <Form.Item
            label="卡号"
            name="cardNumber"
            rules={[
              { required: true, message: '请输入卡号' },
              { pattern: /^[A-Z0-9]{6,20}$/, message: '卡号格式不正确' }
            ]}
          >
            <Input placeholder="请输入卡号" />
          </Form.Item>
        </Form>
      </Modal>
    </div>
  );
};